export default __webpack_public_path__ + "static/media/11.aad6a093.jpg";